<div id="weathermap" leaflet
  style="width:100%;height:100%"
  [leafletLayers]="markers">

</div>
